/**
 * Central registry of feature gate keys used in the application.
 * Add new feature gate keys here as string constants.
 */
export const featureGateKeys = {
  /**
   * COMMUNITY_APP_UPDATES
   * @link https://switcheroo.atlassian.com/ui/gates/e721eb2d-646b-4905-a21d-9060f599cb3a/key/community-app-updates
   * @description Controls visibility of the /updates page. When off, users are
   * redirected to the community home page.
   * @returns true if the App Updates UI should be shown
   */
  publicAppUpdatesUi: 'community-app-updates',
  /**
   * COMMUNITY_RELEASE_NOTES_PAGE
   * @link https://switcheroo.atlassian.com/ui/gates/13529843-7c40-4813-91b2-948c37fe4771/key/community-release-notes-page
   * @description Controls page redirect. When off, users are redirected to the
   * community home page.
   * @returns true if the release notes page should be shown
   */
  communityReleaseNotesPage: 'community-release-notes-page',
  /**
   * PAU_UNREAD_INDICATOR
   * @link https://switcheroo.atlassian.com/ui/gates/7551c1a2-a8d2-4131-86d0-e72a5d827fff/key/pau-unread-indicator
   * @description Controls the unread indicator feature on Public App Updates.
   * When enabled: blue dot on unread release note rows, bold title/app for
   * unread rows, and 'New this week' filter chip in the filter bar.
   * Uses localStorage to track read state (requires analytics consent).
   * OFF by default — safe to merge at any time.
   * @returns true if the unread indicator should be shown
   */
  pauUnreadIndicator: 'pau-unread-indicator',
} as const;

export type FeatureGateValue =
  (typeof featureGateKeys)[keyof typeof featureGateKeys];
